import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/695e446b7683ed0014ecde37_1786606983229_4a6dd922/gopmm_community/src/app/cohort/page.tsx");
